/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Context,
  ProductsSearchParams,
  useProductFactory,
  UseProductFactoryParams,
} from '@vue-storefront/core';

import logThrottledRequests from '../helpers/logThrottledRequests';
import { ProductsResponse } from '../types';

const params: UseProductFactoryParams<ProductsResponse, any> = {
  productsSearch: async (
    context: Context,
    params: ProductsSearchParams,
  ): Promise<ProductsResponse> => {
    // check if cart is already initiated
    const { customQuery, ...searchParams } = params;

    if (params.recommended) {
      const response = await context.$shopify.api.getRecommendedProducts(params);

      logThrottledRequests('getRecommendedProducts', params, response);

      return response;
    }

    const fetchProductPromises = [
      context.$shopify.api.getProduct(searchParams, customQuery),
    ].concat(
      params.buyer ? [await context.$shopify.api.getProductRecommendedRetailPrice(params)] : [],
    );

    const [productResponse, rrpResponse] = await Promise.all(fetchProductPromises);

    if (Array.isArray(productResponse)) {
      const mergedProducts = productResponse.map((pr, index) => ({
        ...pr,
        ...(rrpResponse ? rrpResponse[index] : {}),
      }));
      logThrottledRequests('getProduct', params, mergedProducts as any);

      return mergedProducts as any;
    }

    const mergedProduct = {
      ...productResponse,
      ...rrpResponse?.pop() ?? {},
    };

    logThrottledRequests('getProduct', params, mergedProduct);

    return mergedProduct;
  },
};

const useProduct = useProductFactory<ProductsResponse, any>(params);

export default useProduct;
